// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9c261570","453":"9eb9aed6"}[chunkId] + ".chunk.js";
};